import axios from "axios";
import EnvManager from '../../config/envManager';

const backend = axios.create({
  baseURL: `${EnvManager.BACKEND_URL}/api`,
  withCredentials: true
});

export const getClients = async () => {
  try {
    const response = await backend.get('/clients');
    return response.data;
  }
  catch (error) {
    return null;
  }
};
